import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props { children: ReactNode }
interface State { failed: boolean }

// Without a boundary, any render or lazy-import failure unmounts the tree and
// leaves a blank page with nothing but a console message — which is exactly how
// a stale chunk after a deploy presented itself.
export class AppErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[score-creator] falha ao renderizar a tela:", error, info.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="grid min-h-[60vh] content-center justify-items-center gap-2.5 px-5 py-12 text-center text-muted [&_strong]:text-[19px] [&_strong]:text-ink [&_p]:m-0 [&_p]:text-sm [&_button]:rounded-[9px] [&_button]:border [&_button]:border-line [&_button]:bg-surface-raised [&_button]:px-[18px] [&_button]:py-[9px] [&_button]:font-extrabold [&_button]:text-ink" role="alert">
        <strong>Não foi possível abrir esta tela.</strong>
        <p>Se o problema continuar, recarregue a página.</p>
        <button type="button" onClick={() => window.location.reload()}>Recarregar</button>
      </div>
    );
  }
}
